import React, { useState, useEffect, useRef } from 'react';
import * as rsuite from 'rsuite';
import { isMobile } from 'react-device-detect';

// ارتفاع جدول را طوری تنظیم می کند که فقط خود جدول اسکرول بخورد.
//
// جدول با autoHeight تا آخرین سطر باز می شود و سرستون از بالای صفحه بیرون
// می رود؛ با ارتفاع ثابت، خود جدول اسکرول می خورد و سرستون سر جایش می ماند.
//
// قبلا ارتفاع از کف پنجره حساب می شد و همین دو تا اسکرول می ساخت: کف ناحیه
// اسکرول قاب برنامه (.AppScroll) بالاتر از کف پنجره است و زیر خود جدول هم
// حاشیه داخلی پنل ها هست. جمعشان چند پیکسل بیشتر از فاصله ای بود که کنار
// گذاشته می شد، و همان چند پیکسل اسکرول دوم را در می آورد.
//
// حالا این حاشیه ها به جای حدس زدن، اندازه گرفته می شوند: چقدر بالای جدول
// پر شده، چقدر زیرش مانده، و چقدر جا هست. این حساب به تعداد فیلترهای بالای
// صفحه و به اینکه صفحه اسکرول خورده یا نه کار ندارد.
const MinTableHeight = 260;
const BottomGap = 8;

//--> نزدیک ترین والدی که خودش اسکرول می خورد
const FindScroller = (element) => {
    let node = element ? element.parentElement : null;
    while (node && node !== document.body) {
        const overflow = window.getComputedStyle(node).overflowY;
        if (overflow === 'auto' || overflow === 'scroll') {
            return node;
        }
        node = node.parentElement;
    }
    return null;
};

const useFillHeight = (enabled) => {
    const holderRef = useRef();
    const [height, setHeight] = useState(MinTableHeight);

    useEffect(() => {
        if (!enabled) {
            return undefined;
        }
        const calc = () => {
            const holder = holderRef.current;
            if (!holder) {
                return;
            }
            const box = holder.getBoundingClientRect();
            const scroller = FindScroller(holder);

            //--> بیرون از قاب برنامه، خود پنجره ناحیه اسکرول است
            if (!scroller) {
                const only = window.innerHeight - box.top - BottomGap;
                setHeight(only > MinTableHeight ? only : MinTableHeight);
                return;
            }

            //--> کف واقعی محتوا از روی خود عنصر محتوا خوانده می شود، نه از
            //--> scrollHeight: مرورگر scrollHeight را هیچ وقت کمتر از
            //--> clientHeight نمی دهد، پس وقتی محتوا جا شده باشد اختلافشان
            //--> صفر می شود و جدول هر بار کمی کوتاه تر می شد تا به کف برسد.
            const contentEl = scroller.lastElementChild;
            if (!contentEl) {
                return;
            }
            const scrollerBox = scroller.getBoundingClientRect();

            //--> فاصله بالای جدول از سر محتوا، و هر چه زیر جدول مانده
            //--> (حاشیه داخلی پنل ها). هر دو مستقل از جای اسکرول اند.
            const above = box.top - scrollerBox.top + scroller.scrollTop;
            const below = contentEl.getBoundingClientRect().bottom - box.bottom;

            const room = scroller.clientHeight - above - below - BottomGap;
            const next = room > MinTableHeight ? room : MinTableHeight;

            //--> اختلاف کمتر از یک پیکسل را نادیده می گیریم: عوض کردن ارتفاع
            //--> جدول خودش ناظر اندازه را دوباره صدا می زند و بدون این شرط
            //--> حلقه می شود
            setHeight(prev => Math.abs(next - prev) > 1 ? next : prev);
        };
        calc();
        window.addEventListener('resize', calc);

        //--> نوار دکمه های بالای جدول با آمدن و رفتن لودر قد می کشد و جای
        //--> شروع جدول جابجا می شود؛ اندازه گیری فقط موقع سوار شدن کافی نیست.
        //--> ناظر روی والدِ جدول است نه روی ناحیه اسکرول: ناحیه اسکرول یک
        //--> قاب با اندازه ثابت است و با عوض شدن محتوایش تغییر قد نمی دهد،
        //--> پس هیچ وقت شلیک نمی کرد.
        let observer = null;
        let frame = 0;
        const content = holderRef.current ? holderRef.current.parentElement : null;
        if (content && typeof ResizeObserver !== 'undefined') {
            //--> اندازه گیری داخل فریم بعدی: خود این ناظر با عوض شدن ارتفاع
            //--> جدول دوباره صدا زده می شود و مرورگر برای صدا زدن در همان
            //--> فریم هشدار «ResizeObserver loop» می دهد
            observer = new ResizeObserver(() => {
                window.cancelAnimationFrame(frame);
                frame = window.requestAnimationFrame(calc);
            });
            observer.observe(content);
        }

        return () => {
            window.removeEventListener('resize', calc);
            //--> فریم معلق نباید بعد از پیاده شدن اجرا شود
            window.cancelAnimationFrame(frame);
            if (observer) {
                observer.disconnect();
            }
        };
    }, [enabled]);

    return [holderRef, height];
};

//--> فیلتر یک ستون: مقدار خالی یعنی «همه». متن با «شامل بودن» و بدون
//--> حساسیت به بزرگی/کوچکی حروف، select با برابری دقیق.
const MatchesFilter = (row, filter, value) => {
    if (value === undefined || value === null || value === '') {
        return true;
    }
    const cell = row[filter.key];
    if (filter.type === 'select') {
        return String(cell) === String(value);
    }
    return String(cell ?? '').toLowerCase().includes(String(value).toLowerCase());
};

//--> گزینه های select: اگر صفحه صریحا نداده باشد، از مقادیر یکتای همان
//--> ستون در کل داده (نه داده فیلترشده) ساخته می شود. برای ستون هایی مثل
//--> stateComment/priorityComment که خودشان متن فارسی آماده اند کافی است.
const FilterOptions = (rows, filter) => {
    if (filter.options) {
        return filter.options;
    }
    const seen = new Set();
    const options = [];
    rows.forEach(row => {
        const value = row[filter.key];
        if (value === undefined || value === null || value === '' || seen.has(value)) {
            return;
        }
        seen.add(value);
        options.push({ label: String(value), value });
    });
    return options;
};

// جدول rsuite روی موبایل بد است: عرض ستون ها ثابت است و کاربر مجبور
// می شود افقی اسکرول کند تا ستون عملیات را پیدا کند.
//
// این پوشش روی دسکتاپ دقیقا همان جدولی را نشان می دهد که صفحه ساخته
// (به صورت children، پس کد جدول اصلا دست نمی خورد) و روی موبایل به جای
// آن یک لیست کارت عمودی می سازد.
//
// استفاده:
//   <ResponsiveList data={List} emptyText="..." renderCard={(row, i) => (...)}>
//       <Table ...> ... </Table>
//   </ResponsiveList>
// fillHeight یعنی جدول تا پایین پنجره کشیده شود و خودش اسکرول بخورد.
// برای صفحه های فهرست روشن است؛ برای جدول های کوچک داخل کارت های داشبورد نه.
//
// filters (اختیاری) یعنی یک ردیف فیلتر بالای جدول/لیست: آرایه ای از
// { key, label, type: 'text' | 'select', options? }. فیلتر کاملا سمت
// کلاینت است و روی همان داده ای که صفحه لود کرده اعمال می شود - جای
// جستجوی سمت سرور صفحه هایی مثل تیکت ها را نمی گیرد، رویش اضافه می شود.
const ResponsiveList = ({ data, renderCard, emptyText, loading, fillHeight, filters, children }) => {

    const rows = data ? data : [];
    const hasFilters = Array.isArray(filters) && filters.length > 0;
    const [filterValues, setFilterValues] = useState({});
    const [holderRef, tableHeight] = useFillHeight(fillHeight && !isMobile);

    const HandleFilterChange = (key, value) => {
        setFilterValues(prev => ({ ...prev, [key]: value }));
    };
    const ClearFilters = () => setFilterValues({});
    const HasActiveFilters = Object.values(filterValues).some(v => v !== undefined && v !== null && v !== '');

    const filteredRows = hasFilters
        ? rows.filter(row => filters.every(f => MatchesFilter(row, f, filterValues[f.key])))
        : rows;

    const FilterBar = hasFilters ? (
        <rsuite.Stack wrap spacing={12} className="mb-2" style={{ direction: 'rtl' }}>
            {
                filters.map(f => (
                    <div key={f.key} style={{ minWidth: 160 }}>
                        <div style={{ fontSize: 12, color: '#898781', marginBottom: 2 }}>{f.label}</div>
                        {
                            f.type === 'select' ?
                                <rsuite.SelectPicker
                                    data={FilterOptions(rows, f)}
                                    value={filterValues[f.key] ?? null}
                                    onChange={value => HandleFilterChange(f.key, value)}
                                    onClean={() => HandleFilterChange(f.key, undefined)}
                                    searchable={false}
                                    placeholder="همه"
                                    style={{ width: 160 }}
                                />
                                :
                                <rsuite.Input
                                    value={filterValues[f.key] ?? ''}
                                    onChange={value => HandleFilterChange(f.key, value)}
                                    placeholder="جستجو..."
                                    style={{ width: 160 }}
                                />
                        }
                    </div>
                ))
            }
            {
                HasActiveFilters ?
                    <rsuite.Button appearance="link" size="sm" onClick={ClearFilters}>
                        پاک کردن فیلترها
                    </rsuite.Button>
                    :
                    null
            }
        </rsuite.Stack>
    ) : null;

    if (!isMobile) {
        const cloneProps = {};
        if (fillHeight) {
            cloneProps.height = tableHeight;
            cloneProps.autoHeight = false;
        }
        if (hasFilters) {
            cloneProps.data = filteredRows;
        }
        return (
            <>
                {FilterBar}
                <div style={{ direction: 'rtl' }} ref={holderRef}>
                    {
                        //--> ارتفاع و autoHeight را به خود جدول تحمیل می کنیم تا هر
                        //--> صفحه مجبور نباشد این محاسبه را تکرار کند
                        React.isValidElement(children) && Object.keys(cloneProps).length > 0 ?
                            React.cloneElement(children, cloneProps)
                            :
                            children
                    }
                </div>
            </>
        );
    }

    const mobileRows = hasFilters ? filteredRows : rows;

    if (loading) {
        return (
            <>
                {FilterBar}
                <div style={{ padding: 24, textAlign: 'center' }}>
                    <rsuite.Loader content="در حال دریافت اطلاعات..." />
                </div>
            </>
        );
    }

    if (mobileRows.length === 0) {
        return (
            <>
                {FilterBar}
                <div style={{ padding: 24, textAlign: 'center', color: '#898781' }}>
                    {
                        hasFilters && rows.length > 0 ?
                            'موردی با این فیلتر یافت نشد'
                            :
                            (emptyText ? emptyText : 'موردی برای نمایش وجود ندارد')
                    }
                </div>
            </>
        );
    }

    return (
        <>
            {FilterBar}
            <div style={{ direction: 'rtl' }}>
                {
                    mobileRows.map((row, index) => (
                        <rsuite.Panel key={index} bordered className='bg-white mb-2'>
                            {renderCard(row, index)}
                        </rsuite.Panel>
                    ))
                }
            </div>
        </>
    );
}

// یک خط برچسب/مقدار داخل کارت. برای اینکه همه کارت های برنامه یک شکل باشند
// همه صفحه ها از همین استفاده می کنند، نه از چیدمان دستی خودشان.
export const CardField = ({ label, children }) => (
    <rsuite.Stack justifyContent="space-between" className='mb-1'>
        <span style={{ color: '#898781', fontSize: 12 }}>{label}</span>
        <span style={{ fontSize: 13 }}>{children}</span>
    </rsuite.Stack>
);

// عنوان کارت - همیشه اولین چیزی که خوانده می شود
export const CardTitle = ({ children }) => (
    <div style={{ fontWeight: 'bold', marginBottom: 8 }}>{children}</div>
);

// ردیف عملیات، همیشه پایین کارت.
// چیدمان در Style.css است: دکمه ها می شکنند و فاصله شان یکسان می ماند،
// و حاشیه های دستی خود دکمه ها خنثی می شود تا سه دکمه فارسی روی
// صفحه باریک به هم نریزند.
export const CardActions = ({ children }) => (
    <div className='CardActions'>{children}</div>
);

export default ResponsiveList;
